import { render, staticRenderFns } from "./TicketModal.vue?vue&type=template&id=50473f73&scoped=true"
import script from "./TicketModal.vue?vue&type=script&lang=js"
export * from "./TicketModal.vue?vue&type=script&lang=js"
import style0 from "./TicketModal.vue?vue&type=style&index=0&id=50473f73&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50473f73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50473f73')) {
      api.createRecord('50473f73', component.options)
    } else {
      api.reload('50473f73', component.options)
    }
    module.hot.accept("./TicketModal.vue?vue&type=template&id=50473f73&scoped=true", function () {
      api.rerender('50473f73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticketManager/TicketModal.vue"
export default component.exports